import useBet from "context/useBet";

const oddsFormat = "percent_roi"; // decimal, percent_roi

function formatOdds(odds) {
  if (isNaN(odds) || odds === null || odds === undefined) {
    return "-";
  }
  if (oddsFormat === "percent_roi") {
    // Show profit % (odds-1), not payout %; e.g., 1.10 => +10%
    return "+" + Math.floor((odds - 1) * 100) + "%";
  } else if (oddsFormat === "decimal") {
    return odds;
  }
}

const OddsButton1 = ({ betId, title, odds, disabled }) => {
  // const { selectedBet, setSelectedBet } = useBet();
  const { setSelectedBet } = useBet();

  const handleClick = () => {
    if (!disabled) {
      console.log(`Placing bet on ${betId} with odds ${odds}`);
      setSelectedBet(betId);
    }
  };

  const disabledClass = disabled ? "disabled-element" : "";
  return (
    <div
      className={`top_matches__innercount-item clickable-active py-1 px-5 rounded-3 n11-bg text-center ${disabledClass}`}
      onClick={handleClick}
    >
      <span className="fw-bold fs-seven d-block mb-2 text-nowrap">{title}</span>
      <span className="d-block text-nowrap text-warning">
        {formatOdds(odds)}
      </span>
    </div>
  );
};

export default OddsButton1;
